import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header p-d-flex" }
const _hoisted_2 = { class: "p-input-icon-left p-mr-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "kpi-edit-scorecard-select-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.dialog.style,
    contentStyle: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.dialog.contentStyle,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.scorecardList')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeScorecardAssociations
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        onClick: _ctx.addScorecardAssociations
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.scorecardList,
        selection: _ctx.selectedScorecard,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedScorecard = $event)),
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        KpiDocumentDesignerKpiListCardDescriptor: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.selectScorecardGlobalFilterFields,
        responsiveLayout: "stack",
        breakpoint: "960px",
        scrollable: true,
        scrollHeight: "80vh"
      }, {
        header: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                type: "text",
                placeholder: _ctx.$t('common.search'),
                "data-test": "filterInput"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "single",
            headerStyle: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.selectColumnStyle,
            style: _ctx.KpiDocumentDesignerScorecardsListCardDescriptor.selectColumnStyle
          }, null, 8, ["headerStyle", "style"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "name",
            header: _ctx.$t('common.name'),
            key: "name",
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "creationDate",
            header: _ctx.$t('common.creationDate'),
            key: "dateCreation",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.creationDate)), 1)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "selection", "filters", "KpiDocumentDesignerKpiListCardDescriptor"])
    ]),
    _: 1
  }, 8, ["style", "contentStyle", "visible"]))
}